import TooltipLabel from './TooltipLabel';

export default TooltipLabel;
